import styled from 'styled-components';
import { Modal } from '@sede-enterprise/shell-ds-react-framework';
import theme from 'styled-theming';

export const backgroundColor = theme('name', {
  light: '#fff',
  dark: 'rgb(52, 52, 52)',
});

const textColor = theme('name', {
  dark: 'rgb(255, 255, 255)',
  light: 'rgb(41, 41, 41)',
});

// eslint-disable-next-line import/prefer-default-export
export const ShellModal = styled(Modal)`
  .shell-modal-container-wrap,
  .shell-modal-container-mask {
    z-index: 10000;
  }
  .shell-modal-container-title {
    div:has(h1) {
      width: 100%;
    }
    .draggable-title {
      cursor: move;
      border: none;
      background: none;
      color: ${textColor};
      text-wrap: auto;
      text-align: left;
      ::first-letter {
        text-transform: capitalize;
      }
    }
  }
  .shell-modal-container-body {
    background-color: ${backgroundColor};
  }
`;
